import { Message } from './types';

export const MESSAGE_REGEX = {
  /**
   * Starting comment from Zendesk Agent Workspace tickets
   * Example: "(13:02:15) *** Edwin WD joined the chat ***"
   */
  beginning: /\(\d{2}:\d{2}:\d{2}\) \*{3} (.+) \*{3}/,

  /**
   * Ending comment from Zendesk Agent Workspace tickets
   * Example: "(13:02:15) *** Edwin WD left the chat ***"
   */
  ending: /\(\d{2}:\d{2}:\d{2}\) \*{3} (.+) \*{3}/,

  /**
   * Each message part should have this format
   * Example: "(17:13:36) CS Asev Revanzki: Hi ini agent Preprod, ada yang bisa saya bantu?"
   */
  messagePart: /\(\d{2}:\d{2}:\d{2}\) (.+): (.+)/,

  /**
   * Attachment message will have this format
   * Example: "(21:20:39) CS Asev Revanzki uploaded: Screenshot 2023-11-20 at 21.20.26.png"
   * Any attachment message would have the following messages containing attachment URL, type and size
   */
  messageAttachment: /\(\d{2}:\d{2}:\d{2}\) (.+) uploaded: (.+)/,
  attachmentUrl: /URL: (.+)/,
  attachmentType: /Type: (.+)/,
  attachmentSize: /Size: (\d+)/,
};

export const MESSAGE_SCHEMA: Message = {
  msg: '',
  nick: '',
  displayName: '',
  timestamp: 0,
  status: '',
  imgUrl: '',
  attachmentType: '',
  attachmentSize: '',
};
